import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import companiesApi from "src/configs/apis/companies";
import AssignStatusProgressComponent from "./assignStatusProgress.component";

function AssignStatusProgressContainer({
  assignUuid,
  initialProgress = 0,
  initialStatus,
}) {
  const [status, setStatus] = useState(initialStatus);
  const [progress, setProgress] = useState(initialProgress);
  const dispatch = useDispatch();

  const intervalRef = useRef(null);

  const getData = () => {
    companiesApi
      .getReassignProgress(assignUuid)
      .then((res) => {
        setStatus(res.data.status);
        setProgress(res.data.progress);

        if (res.data.status === "success" || res.data.status === "failed") {
          clearInterval(intervalRef.current);
        }
      })
      .catch(() => {
        setStatus("failed");
        setProgress(0);
        clearInterval(intervalRef.current);
      });
  };

  useEffect(() => {
    if (initialStatus !== "success" && initialStatus !== "failed") {
      intervalRef.current = setInterval(() => {
        getData();
      }, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [dispatch, assignUuid]);

  return <AssignStatusProgressComponent progress={progress} status={status} />;
}

export default AssignStatusProgressContainer;
